'use es6';

import Actions from 'AdsUI/lib/Actions';
export default ((state = null, action) => {
  switch (action.type) {
    case Actions.AUTH_FETCH:
      return action.payload;

    default:
      return state;
  }
});